import React, { createContext, useContext, useState } from 'react';
import PopupPlaceholder from './PopupPlaceholder';
import CancelIcon from '../svgIcons/Cancel';

const PopupContext = createContext();

export const usePopup = () => {
    const context = useContext(PopupContext);
    if (!context) {
        throw new Error('usePopup must be used within a PopupProvider');
    }
    return context;
};

export const PopupProvider = ({ children }) => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [popupProps, setPopupProps] = useState({});

    const openPopup = (props = {}) => {
        setPopupProps(props);
        setIsPopupOpen(true);
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        setPopupProps({});
    };

    const value = {
        isPopupOpen,
        openPopup,
        closePopup,
        popupProps
    };

    return (
        <PopupContext.Provider value={value}>
            {children}

            {isPopupOpen && (
                <div className='fixed inset-0 z-50 flex items-center justify-center'>
                    <div
                        className='absolute inset-0 bg-black bg-opacity-50'
                        onClick={closePopup}
                    />
                    <div className='relative w-full h-full'>
                        <div className='relative w-full h-full'>
                            <PopupPlaceholder {...popupProps} />
                            <button
                                onClick={e => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    closePopup();
                                }}
                                className='bg-transparent cursor-pointer absolute top-8 right-2 z-10'
                            >
                                <CancelIcon width={22} height={22} />
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </PopupContext.Provider>
    );
};

const GlobalPopupWrapper = ({ children }) => {
    return <PopupProvider>{children}</PopupProvider>;
};

export default GlobalPopupWrapper;
